import React from 'react';
import { Message } from 'semantic-ui-react';

class ErrorBoundary extends React.Component {
  state = { 
    hasError: false,
    errorMessage: '' 
  };

  static getDerivedStateFromError(error) {
    return { 
      hasError: true,
      errorMessage: error?.toString() || 'An unknown error occurred'
    };
  }

  componentDidCatch(error, info) {
    // Just log the error safely
    console.error('Error:', error);
    if (info) {
      console.error('Component Stack:', info.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Message negative>
          <Message.Header>Something went wrong</Message.Header>
          <p>{this.state.errorMessage}</p>
        </Message>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;